import { TranslatableText, Translate } from '@dreryk/react-common';
import { Modal, ModalCloseButton, ModalConfirmButton, ModalWidth } from '@dreryk/react-components';

import { translationKeys } from '../translations';

type PatientMedicalInformationFaultModalProps = Readonly<{
   description: TranslatableText;
   onClose: VoidFunction;
}>;

export const PatientMedicalInformationFaultModal = (props: PatientMedicalInformationFaultModalProps): JSX.Element => {
   return (
      <Modal
         testId={'patientMedicalInformationFault'}
         title={translationKeys.youCannotRemoveAnEntryInTheDocumentation}
         width={ModalWidth.NORMAL}
      >
         <Translate>{props.description}</Translate>
         <ModalConfirmButton label={translationKeys.close} onClick={props.onClose} />
         <ModalCloseButton onClick={props.onClose} />
      </Modal>
   );
};
